module.exports = __webpack_public_path__ + "img/employee-1.c7fc1c4b.jpg";